import "./JrxmlFormPage.css";
import { TextInput, Text, Select } from "@mantine/core";
import React, { useEffect } from "react";
import { ReportInfo, ReportProps } from "../../../../types/types";
import { QueryHeaders } from "./QueryHeaders/QueryHeaders";
import { ArrayUtils } from "../../../../utils/arrayUtils";

export function JrxmlFormPage(props: ReportProps) {
  useEffect(() => {
    if (props.reportInfo.reportDefenition) {
      handleChangeDropDown("jrxml")
    }
  },[]);

  //sets the jrxml path to reportDefenition key in props
  const handleChange = (
    event: any,
    reportInfo: ReportInfo,
    setReportInfo: any
  ) => {
    const value = event.target.value;
    reportInfo.reportDefenition = value;
    setReportInfo(reportInfo);
    props.setReportState((currentState) => ({
      ...currentState,
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "reportDefenitionError"
      ),
    }));
  };

  const reportDefenitionError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "reportDefenitionError")
      .map((error) => error.message)[0];
  const simpleReportError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error: any) => error.property === "simpleReportError")
      .map((error) => error.message)[0];

  const handleChangeDropDown = (event: any) => {
    props.setValueReportType(event);
    if(event === "simple"){
      if(props.reportInfo.reportDefenition){
        props.reportInfo.reportDefenition="";
      }
      if(props.reportInfo.extendedAttributes && !props.reportInfo.extendedAttributes?.headers){
         props.reportInfo.extendedAttributes.headers = {};
      }
    }else{
      if(props.reportInfo.extendedAttributes?.headers){
        delete props.reportInfo.extendedAttributes.headers;
        props.columns['Report_Columns'].list = [];
      }
    }
    //sets show input to true when jrxml is selected
    props.setShowInput(event === "jrxml");

    //sets show draggable to true when simple is selected
    props.setShowDraggableList(event === "simple");
    props.setReportState((currentState) => ({
      ...currentState,
      validationErrors: [],
    }));
  };



  return (
    <div style={{ width: "100%"}}>
      <div
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="full-width">
          {/* dropdown */}
          <Select
            label="Select report type"
            placeholder="JRXML"
            name="reportType"
            value={
              props.reportInfo.reportDefenition
                ? "jrxml"
                : props.valueReportType
            }
            onChange={handleChangeDropDown}
            disabled={props.reportInfo.viewEditStatus === "VIEW" ? true : false}
            data={[
              { value: "jrxml", label: "JRXML" },
              { value: "simple", label: "SIMPLE" },
            ]}
          />

          {/* on handleChange when jrxml is selected it sets show input as true and an input field appears*/}
          {props.showInput && (
            <TextInput
              disabled={
                props.reportInfo.viewEditStatus === "VIEW" ? true : false
              }
              placeholder="Enter jrxml path"
              label="Enter jrxml path"
              name="jrxmlPath"
              value={props.reportInfo.reportDefenition}
              onChange={(e) =>
                handleChange(e, { ...props.reportInfo }, props.setReportInfo)
              }
            />
          )}
          {reportDefenitionError && (
            <Text color="red">{reportDefenitionError}</Text>
          )}
        </div>
      </div>
      {/* on handleChange when simple is selected it sets show draggable as true and QueryHeaders is called*/}
      {props.showDraggableList && <QueryHeaders {...props} />}
      {simpleReportError && <Text color="red">{simpleReportError}</Text>}
    </div>
  );
}
